// extracted by mini-css-extract-plugin
export default {"coinpurse_wrapper":"CoinPurse_coinpurse_wrapper__dXhiX","coinInput2":"CoinPurse_coinInput2__KueLM","img2":"CoinPurse_img2__jk7qm","shuffles":"CoinPurse_shuffles__Zk1en"};